import React, { useState, useEffect } from 'react';
import { FaPaperPlane } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import { emailConfig } from '../config/emailConfig';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  useEffect(() => {
    emailjs.init(emailConfig.publicKey);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        phone: formData.phone,
        company: formData.company,
        message: formData.message,
        to_name: 'ליהי',
      };

      await emailjs.send(
        emailConfig.serviceId,
        emailConfig.templateId,
        templateParams
      );

      setIsSubmitting(false);
      setSubmitMessage('תודה! הודעתך נשלחה בהצלחה. נחזור אליך בקרוב.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      });

      setTimeout(() => {
        setSubmitMessage('');
      }, 5000);
    } catch (error) {
      console.error('Failed to send email:', error);
      setIsSubmitting(false);
      setSubmitMessage('אופס! משהו השתבש. אנא נסה שוב או צור קשר ישירות דרך הטלפון.');
      
      setTimeout(() => {
        setSubmitMessage('');
      }, 5000);
    }
  };

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="contact-header">
          <h2 className="heading-lg text-center">
            בואו <span className="gradient-text">נתחיל</span>
          </h2>
          <p className="text-lg text-center">
            מוכנים לקחת את העסק שלכם לשלב הבא? צרו איתי קשר ונתחיל לעבוד יחד!
          </p>
        </div>

        <div className="contact-content">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="שם מלא *"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>
              
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="כתובת אימייל *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="מספר טלפון *"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>
              
              <div className="form-group">
                <input
                  type="text"
                  name="company"
                  placeholder="שם החברה"
                  value={formData.company}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>
            </div>
            
            <div className="form-group">
              <textarea
                name="message"
                placeholder="ספרו לי בקצרה על הצרכים שלכם ואיך אני יכולה לעזור לכם *"
                value={formData.message}
                onChange={handleChange}
                required
                rows="6"
                className="form-input form-textarea"
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="btn btn-primary form-submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="loading"></span>
                  <span>שולח...</span>
                </>
              ) : (
                <>
                  <FaPaperPlane />
                  <span>שלח הודעה</span>
                </>
              )}
            </button>
            
            {submitMessage && (
              <div className="submit-message">
                {submitMessage}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;